import { PaginatedCollectionType } from '@2wunder/klarx-tool'

export type QlGroupedInvoicesResponseType = {
  invoices: PaginatedCollectionType<IInvoice>
  invoiceGroupBy: QlInvoiceGroupBy
}

export type QlInvoiceGroupBy = {
  month: QlInvoiceGroup[]
}

export type QlInvoiceGroup = {
  key: string
  count: number
  sum: {
    financialInfosNetTotal: number
    financialInfosGrossTotal: number
  }
  __typename?: string
}
export const invoiceMonthNormalizer = (data: QlGroupedInvoicesResponseType) => {
  return mapInvoicesToGroup(data.invoiceGroupBy.month, data.invoices.nodes)
}

export const mapInvoicesToGroup = (
  groups: QlInvoiceGroup[] = [],
  invoices: IInvoice[] = []
): IInvoiceGroup[] => {
  const invoiceGroups: IInvoiceGroup[] = []

  groups.forEach((group) => {
    const mappedInvoices = invoices.filter((invoice) => invoice.period === group.key)

    invoiceGroups.push({
      id: parseInt(group.key.replace('-', '')),
      key: group.key,
      netTotal: group.sum.financialInfosNetTotal,
      grossTotal: group.sum.financialInfosGrossTotal,
      invoices: mappedInvoices,
      __typename: 'InvoiceGroup'
    })
  })

  return invoiceGroups
}
